document.querySelectorAll('.acc-header').forEach(button => {
  button.addEventListener('click', () => {
    const item = button.parentElement;
    item.classList.toggle('open');
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const footer = document.querySelector('.sticky-footer');
  const buttons = document.querySelectorAll('.footer-btn');
  let lastScrollPosition = 0;
  const SCROLL_THRESHOLD = 1200;
  
  buttons.forEach(button => {
    const url = button.dataset.url;
    if (url) {
      button.href = url;
      
      // ページ内リンクの場合のスムーズスクロール処理
      if (url.startsWith('#')) {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          const targetElement = document.querySelector(url);
          if (targetElement) {
            // スクロール位置の調整（固定ヘッダーがある場合は、その高さを考慮）
            const headerOffset = 90; // 固定ヘッダーがある場合は、その高さをピクセルで指定
            const elementPosition = targetElement.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
  
            window.scrollTo({
              top: offsetPosition,
              behavior: "smooth"
            });
          }
        });
      }
    }
    
    // LINEボタンの場合は新規タブで開く
    if (button.classList.contains('line-btn')) {
      button.target = '_blank';
      button.rel = 'noopener noreferrer';
    }
  });

  // スクロール表示制御
  window.addEventListener('scroll', function() {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

    if (currentScroll > SCROLL_THRESHOLD) {
      footer.classList.add('visible');
    } else {
      footer.classList.remove('visible');
    }

    lastScrollPosition = currentScroll;
  });
});
